import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createIcon } from "@chakra-ui/react/icon";
export default createIcon({
    displayName: "Circle",
    viewBox: "0 0 24 24",
    path: (_jsxs(_Fragment, { children: [_jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }), _jsx("path", { d: "M12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5Z", fillRule: "evenodd", clipRule: "evenodd", fill: "currentColor" })] })),
});
